import GameEnvironment from './GameEnvironment';
import LandingAppBarItems from './LandingAppBarItems';

const AppbarModes = {

  GAME_ENVIRONMENT: GameEnvironment,
  ARTICLE: LandingAppBarItems,
};

export default AppbarModes;
